import React from 'react';
import { Section } from './ui/Section';
import { X } from 'lucide-react';
export function WhatThisIsNot() {
  const nots = ['A cleaning program', 'A rigid schedule', '"Wake up at 5am and journal"'];
  return <Section background="white" className="text-center" data-id="element-169">
      <h2 className="text-2xl md:text-3xl font-serif text-[#4A4238] mb-10" data-id="element-170">
        What this is NOT
      </h2>

      <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-12 mb-10" data-id="element-171">
        {nots.map((item, index) => <div key={index} className="flex items-center justify-center gap-2 text-[#8C7E6E] font-medium" data-id="element-172">
            <X size={20} className="text-red-400" data-id="element-173" />
            <span data-id="element-174">{item}</span>
          </div>)}
      </div>

      <p className="text-xl md:text-2xl font-serif text-[#7BA99E] font-medium" data-id="element-175">
        This is a postpartum-safe reset loop.
      </p>
    </Section>;
}